module.exports = __webpack_public_path__ + "static/media/17.bc02358f.jpg";